/**
 * LoadingSpinner - Re-exports from base Loader for backwards compatibility
 * @deprecated Use Loader from '@/components/base' instead
 */

export {
    Loader as LoadingSpinner,
    Loader as default,
    PageLoader,
    LoadingContainer,
} from '@/components/base/Loader';

// ButtonSpinner - keeping this as it's unique to this module
import { Loader2 } from 'lucide-react';

export function ButtonSpinner({ className = '' }: { className?: string }) {
    return <Loader2 className={`w-4 h-4 animate-spin ${className}`} />;
}
